import { useQuery } from '@tanstack/react-query'

import { getAllBookingServices } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  bookingId?: ParameterID
}

export function useQueryGetAllBookingServices({ bookingId }: QueryPayload) {
  return useQuery(
    ['QueryGetAllBookingServices', Number(bookingId)],
    async () => await getAllBookingServices(bookingId ?? ''),
    {
      refetchOnWindowFocus: false,
      enabled: isValidParameterID(bookingId),
      initialData: {
        booking_service: [],
        total: 0,
      },
    }
  )
}
